var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_58_692",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.875 0C12.9633 0 0.875 12.0883 0.875 27C0.875 41.9117 12.9633 54 27.875 54C42.7867 54 54.875 41.9117 54.875 27C54.875 12.0883 42.7867 0 27.875 0ZM24.375 36.5263L37.875 28.7321C39.2083 27.9623 39.2083 26.0378 37.875 25.268L24.375 17.4737C23.0417 16.7039 21.375 17.6662 21.375 19.2058V34.7942C21.375 36.3338 23.0417 37.2961 24.375 36.5263Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.875 0C12.9633 0 0.875 12.0883 0.875 27C0.875 41.9117 12.9633 54 27.875 54C42.7867 54 54.875 41.9117 54.875 27C54.875 12.0883 42.7867 0 27.875 0ZM24.375 36.5263L37.875 28.7321C39.2083 27.9623 39.2083 26.0378 37.875 25.268L24.375 17.4737C23.0417 16.7039 21.375 17.6662 21.375 19.2058V34.7942C21.375 36.3338 23.0417 37.2961 24.375 36.5263Z",
    fill: "#2DF6DE",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.875 28.7321L38.875 30.4641L37.875 28.7321ZM24.375 36.5263L23.375 34.7942L23.375 34.7942L24.375 36.5263ZM37.875 25.268L38.875 23.5359L37.875 25.268ZM24.375 17.4737L25.375 15.7417L24.375 17.4737ZM21.375 34.7942L23.375 34.7942V34.7942H21.375ZM2.875 27C2.875 13.1929 14.0679 2 27.875 2V-2C11.8587 -2 -1.125 10.9837 -1.125 27H2.875ZM27.875 52C14.0679 52 2.875 40.8071 2.875 27H-1.125C-1.125 43.0163 11.8587 56 27.875 56V52ZM52.875 27C52.875 40.8071 41.6821 52 27.875 52V56C43.8913 56 56.875 43.0163 56.875 27H52.875ZM27.875 2C41.6821 2 52.875 13.1929 52.875 27H56.875C56.875 10.9837 43.8913 -2 27.875 -2V2ZM36.875 27L23.375 34.7942L25.375 38.2583L38.875 30.4641L36.875 27ZM36.875 27V27L38.875 30.4641C41.5417 28.9245 41.5417 25.0755 38.875 23.5359L36.875 27ZM23.375 19.2058L36.875 27L38.875 23.5359L25.375 15.7417L23.375 19.2058ZM23.375 19.2058V19.2058L25.375 15.7417C22.7083 14.2021 19.375 16.1266 19.375 19.2058H23.375ZM23.375 34.7942V19.2058H19.375V34.7942H23.375ZM23.375 34.7942H23.375L19.375 34.7942C19.375 37.8734 22.7083 39.7979 25.375 38.2583L23.375 34.7942Z",
    fill: "#2DF6DE",
    mask: "url(#path-1-inside-1_58_692)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovePlay);
export default __webpack_public_path__ + "static/media/love-play.9e630258f84da3d0c238a64db9493593.svg";
export { ForwardRef as ReactComponent };